import React from 'react';
import { Button } from '@guildeducationinc/recess';
import { onModalClose } from '@src/components/SearchBar/searchBarHelpers';
import { trackEvent } from '@src/services/analytics';
import { RecommendationType } from '@src/components/Providers/RecommendationsProvider';
import styles from './RecommendedProgramsFooter.module.scss';

interface Props {
	recommendations: RecommendationType[];
}

export const RecommendedProgramsFooter: React.FC<Props> = ({ recommendations }) => {
	const programsLength = recommendations.length > 9 ? 9 : recommendations.length;

	const handleClick = () => {
		trackEvent('Clickable', {
			location: 'autocomplete',
			tag: 'recs_panel_footer',
			text: 'see_all_quiz_recommended_programs',
			type: 'button',
		});
		onModalClose();
	};
	return (
		<>
			{recommendations.length > 3 && (
				<Button
					className={styles.searchButton}
					data-testid='recommended-programs-plugin-footer'
					href='/allprograms#quiz-results'
					onClick={handleClick}
				>
					See all quiz recommended programs ({programsLength})
				</Button>
			)}
		</>
	);
};
